import type { ReactNode } from 'react';
import AddIcon from '@mui/icons-material/Add';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import { Box, Button, Divider, Stack, Typography } from '@mui/material';
import { ActionsMenu, type ActionsMenuProps } from './actions-menu';

interface PageHeaderProps {
  title?: string;
  tag?: ReactNode;
  description?: ReactNode;
  buttonText?: string;
  buttonOnClick?: () => void;
  divider?: boolean;
  backNavigationText?: string;
  handleBackNavigation?: () => void;
  actions?: ActionsMenuProps['actions'];
  buttonDisabled?: boolean;
}

export const PageHeader = ({
  title,
  tag,
  description,
  buttonText,
  buttonOnClick,
  divider = false,
  backNavigationText,
  handleBackNavigation,
  actions,
  buttonDisabled,
}: PageHeaderProps) => {
  const hasActions = actions && actions?.length > 0;

  return (
    <Stack mb={divider ? 0 : 2} justifyContent="space-between" gap={1}>
      <Stack
        direction="row"
        alignItems="center"
        gap={2}
        justifyContent="space-between"
      >
        {backNavigationText && (
          <Button onClick={handleBackNavigation} startIcon={<ChevronLeft />}>
            {backNavigationText}
          </Button>
        )}
        {hasActions && <ActionsMenu actions={actions} />}
      </Stack>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap={2}
        width="100%"
      >
        <Box>
          <Stack direction="row" alignItems="center" flexWrap="wrap" gap={1}>
            <Typography variant="h1" color="primary.dark">
              {title}
            </Typography>
            {tag}
          </Stack>
          {typeof description === 'string' ? (
            <Typography mt={1}>{description}</Typography>
          ) : (
            description
          )}
        </Box>
        {buttonText && (
          <Button
            onClick={buttonOnClick}
            startIcon={<AddIcon />}
            variant="contained"
            disabled={buttonDisabled}
          >
            {buttonText}
          </Button>
        )}
      </Stack>
      {divider && <Divider sx={{ my: 2 }} />}
    </Stack>
  );
};
